



















































































































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import ParameterCategoryApi from '@/api/goods/parameter/category'
import ParameterAttributeApi from '@/api/goods/parameter/attribute'

@Component({
  components: {
    CustomForm
  }
})
export default class GoodsParameterAttr extends AbpBase {
  isCheckAll: boolean = false
  columns: any[] = [
    // {
    //   type: 'selection',
    //   width: 60,
    //   align: 'center'
    // },
    {
      title: '编号',
      key: 'id',
      align: 'center'
    },
    {
      title: '所属分类',
      slot: 'classification',
      align: 'center'
    },
    {
      title: '参数名称',
      key: 'name',
      align: 'center'
    },
    {
      title: '类型',
      slot: 'type',
      align: 'center'
    },
    {
      title: '参数值',
      slot: 'productAttributeValues',
      align: 'left'
    },
    {
      title: '排序',
      width: 100,
      align: 'center',
      key: 'displayOrder'
    },
    {
      title: '操作',
      slot: 'action',
      width: 170,
      align: 'center'
    }
  ]
  loading: boolean = false
  tableData: any[] = []
  currentPage = 1
  pageSize = 10
  totalCount = 0
  validateValue(rule, value, callback) {
    var reg = /[,，]/
    if (reg.test(value)) {
      callback(new Error('内容不能包含中英文逗号'))
    }
    if (value === '') {
      callback(new Error('请输入参数值'))
    }
    callback()
  }
  filters: any = [
    {
      label: '参数分类：',
      type: 'select',
      key: 'productAttributeCategoryId',
      rule: {
        type: 'number', // 添加验证类型
        required: true,
        message: '请选择参数分类',
        trigger: 'change'
      },
      props: {
        placeholder: '请选择参数分类'
      },
      options: []
    },
    {
      label: '参数名称：',
      type: 'input',
      rule: { required: true, message: '请输入参数名称', trigger: 'blur' },
      key: 'name'
    },
    {
      label: '参数类型：',
      type: 'select',
      key: 'type',
      defaultValue: 0,
      props: {
        clearable: false,
        placeholder: '请选择兴趣'
      },
      options: [
        {
          value: 0,
          text: '下拉框'
        },
        {
          value: 1,
          text: '多选框'
        },
        {
          value: 2,
          text: '输入框'
        }
      ]
    },
    {
      label: '参数值：',
      key: 'productAttributeValues',
      rule: { required: true, validator: this.validateValue, trigger: 'blur' },
      settings: {
        style: {
          marginTop: '40px'
        }
      },
      renderContent: (h, item, form, _this) => {
        let $input = h('i-input', {
          props: {
            value: form['productAttributeValues'],
            type: 'textarea',
            autosize: { minRows: 6, maxRows: 10 }
          },
          style: {
            width: '240px'
          },
          ref: 'productAttributeValues',
          on: {
            input: value => {
              form['productAttributeValues'] = value
            }
          }
        })
        return h(
          'div',
          {
            style: {
              color: '#999',
              marginTop: '-24px'
            }
          },
          [
            h(
              'p',
              {
                style: {
                  color: '#999',
                  fontSize: '12px'
                }
              },
              '多个属性值用回车隔开'
            ),
            $input
          ]
        )
      }
    },
    {
      label: '规格排序：',
      type: 'input-number',
      key: 'displayOrder',
      props: {
        min: 0
      }
    }
  ]
  editId: any = null
  editModal: boolean = false
  className = ''
  allAttrCategory: any[] = []

  getAttrTextByArr(arr) {
    return arr.map(item => item.name).join('\n')
  }

  // 列表页内编辑
  // 不要@click="handleEdit",默认会有event参数传进来
  handleEdit(row?) {
    this.editId = (row && row.id) || ''
    this.editModal = true
    let $formEdit: any = this.$refs.formEdit
    if (row) {
      let tempRow: any = {}
      Object.assign(tempRow, row)
      tempRow.productAttributeValues = this.getAttrTextByArr(
        tempRow.productAttributeValues
      )
      // 编辑设值
      $formEdit.setForm(tempRow)
    } else {
      // 新增清空
      $formEdit.reset()
    }
  }

  closeModel() {
    ;(this.$refs.formEdit as any).reset()
    this.editModal = false
  }

  modalOk() {
    let $form: any = this.$refs.formEdit
    $form.submit()
  }

  onSubmit(form, valid) {
    if (valid) {
      let obj: any = {}
      let {
        displayOrder,
        productAttributeValues = '',
        name,
        type,
        productAttributeCategoryId
      } = form
      productAttributeValues = productAttributeValues
        .split('\n')
        .filter(item => item !== '')
      Object.assign(obj, {
        displayOrder,
        productAttributeValues,
        name,
        type,
        productAttributeCategoryId
      })
      ParameterAttributeApi.edit(this.editId, obj).then(res => {
        this.$Message.success(this.editId ? '修改成功' : '添加成功')
        this.editModal = false
        this.getTableData()
      })
    }
  }

  // 列表数据操作
  async created() {
    await this.getAllAttrCategory()
    this.getTableData()
  }

  getTableData() {
    let { pageSize, currentPage } = this
    ParameterAttributeApi.getList(
      pageSize,
      currentPage,
      this.$route.params['id'] || ''
    )
      .then(res => {
        this.loading = false
        let { totalCount, items } = res.data
        this.totalCount = totalCount
        this.tableData = items
      })
      .catch(() => {
        this.loading = false
        this.totalCount = 0
        this.tableData = []
      })
  }

  getProductSalesAttributeValues(arr: any[]) {
    return arr.map(item => item.name).join('，')
  }

  deleteRow(row: any) {
    this.$Modal.confirm({
      title: '提示',
      content: `删除无法恢复, 是否继续?`,
      onOk: () => {
        this.handleDelete(row.id)
      }
    })
  }

  handleDelete(id: string | number) {
    ParameterAttributeApi.deleteById(id).then(res => {
      this.getTableData()
    })
  }

  handleTableAllCancel() {
    this.isCheckAll = false
  }

  handleTableAll() {
    this.isCheckAll = true
  }

  handleSelectChange(selection) {
    this.isCheckAll = selection.length === this.tableData.length
  }

  handleSelectAll() {
    if (!this.tableData.length) return
    ;(this.$refs.selection as any).selectAll(!this.isCheckAll)
  }

  deleteSelectd() {
    let selection = (this.$refs.selection as any).getSelection()
    if (selection.length) {
      console.log('执行删除')
      this.$Modal.confirm({
        title: '批量删除商品规格',
        content: `是否删除已选中的商品规格?`,
        onOk: () => {
          console.log('点了确定了')
        }
      })
    }
  }

  pageChange(currentPage) {
    this.currentPage = currentPage
    this.getTableData()
  }
  pageSizeChange(pageSize) {
    this.pageSize = pageSize
    this.currentPage = 1
    this.getTableData()
  }

  getAllAttrCategory() {
    let ProductAttributeCategoryId = this.$route.params['id'] || ''
    if (ProductAttributeCategoryId) {
      this.filters[0].props.disabled = true
      this.filters[0].defaultValue = Number(ProductAttributeCategoryId)
    }
    ParameterCategoryApi.getAll().then(res => {
      console.log(res)
      let list = JSON.stringify(res.data.items)
      list = list.replace(/"id":/g, '"value":').replace(/"name":/g, '"text":')
      this.filters[0].options = JSON.parse(list)
      let classId = this.$route.params['id']
        ? Number(this.$route.params['id'])
        : null
      this.filters[0].options.forEach(item => {
        if (item.value === classId) {
          this.className = item.text
        }
      })
    })
  }
}
